import styles from './styles.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import * as routes from '../../constants/Routes';
import { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';

export function BottomNavigationBar() {
  const { notificationCount } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeRoute, setActiveRoute] = useState('');

  useEffect(() => {
    const splitPathName = location.pathname.split('/');
    const pathName = splitPathName[1];

    setActiveRoute(pathName);
  }, [location.pathname]);

  const onHandlePage = (route: string) => {
    if (route === 'home') {
      navigate(`${routes.HOME}`);
    }
    if (route === 'redeemAwards') {
      navigate(`${routes.REDEEM_AWARDS}`);
    }
    if (route === 'results') {
      navigate(`${routes.RESULTS}`);
    }
    if (route === 'notifications') {
      navigate(`${routes.NOTIFICATIONS}`);
    }
    if (route === 'profile') {
      navigate(`${routes.PROFILE}`);
    }
    if (route === 'infos') {
      navigate(`${routes.INFOS}`);
    }
  };

  return (
    <>
      <nav className={`${styles.navbarCustom} fixed-bottom d-flex d-lg-none`}>
        <div className={styles.wrapperContent}>
          <ul>
            <li
              onClick={() => onHandlePage('home')}
              className={`${styles.clickable} ${
                activeRoute === 'home' ? styles.active : ''
              } me-4`}
            >
              <i className="material-icons-outlined">home</i>
              <span className={styles.label}>Início</span>
            </li>

            <li
              onClick={() => onHandlePage('redeemAwards')}
              className={`${styles.clickable} ${
                activeRoute === 'redeemAwards' ? styles.active : ''
              } me-4`}
            >
              <i className="material-icons-outlined">emoji_events</i>
              <span className={styles.label}>Premiações</span>
            </li>

            <li
              onClick={() => onHandlePage('results')}
              className={`${styles.clickable} ${
                activeRoute === 'results' ? styles.active : ''
              } me-4`}
            >
              <i className="material-icons-outlined">people</i>
              <span className={styles.label}>Resultados</span>
            </li>

            <li
              onClick={() => onHandlePage('notifications')}
              className={`${styles.clickable} ${
                activeRoute === 'notifications' ? styles.active : ''
              } me-4`}
            >
              {notificationCount && Number(notificationCount) > 0 && (
                <div className="position-relative">
                  <span className={styles.littleBall}>{notificationCount}</span>
                </div>
              )}
              <i className="material-icons-outlined">notifications</i>
              <span className={styles.label}>Notificações</span>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}
